import { AppStorage } from './AppStorage';

class CacheServiceClass {
  readonly store = new AppStorage('cache');

  cache<T>(key: string, provider: () => Promise<T>, deserializer?: (value: any) => T, ttl: number = -1): Promise<T> {
    return provider();
    // const lastUpdatedKey = `__${key}_lastUpdated`;
    // return Promise.all([this.store.getObject(key), this.store.getInt(lastUpdatedKey)]).then(([value, lastUpdated]) => {
    //   const valid = ttl <= 0 || Date.now() - (lastUpdated ?? 0) < ttl;
    //   if (value && valid) {
    //     return deserializer ? deserializer(value) : value;
    //   }
    //   return provider().then((newValue: T) => {
    //     return Promise.all([this.store.setObject(key, newValue), this.store.setInt(lastUpdatedKey, Date.now())])
    //       .then(() => newValue)
    //       .catch(() => newValue);
    //   });
    // });
  }

  async whenFail<T>(
    key: string,
    provider: () => Promise<T>,
    converter?: (value: any) => T,
    defaultValue?: T,
  ): Promise<T | undefined> {
    return provider();
    // try {
    //   const result = await provider();
    //   this.store.setObject(key, result);
    //   return result ?? defaultValue;
    // } catch (e) {}
    // return this.store.getObject(key).then((result) => {
    //   if (result) {
    //     return converter ? converter(result) : result;
    //   }
    //   return defaultValue;
    // });
  }

  evict(key: string) {
    // return this.store.delete(key);
  }
}

const CacheService = new CacheServiceClass();
export default CacheService;
